// extracted by mini-css-extract-plugin
export default {"formHeading":"wG-z","form":"xG-z","submitBtn":"yG-z","disabled":"zG-z","input":"AG-z","error":"BG-z","submitMsg":"CG-z","signIn":"DG-z"};